// src/components/FamilyRow.js
import React, {useState} from "react";
import axios from "axios";
import {
    PencilIcon,
    CheckIcon,
    XMarkIcon,
    TrashIcon,
} from "@heroicons/react/24/outline";
import MemberRow from "./MemberRow";  // ← Добавьте импорт

export default function FamilyRow({
                                      family,
                                      members,  // Список всех гостей из Admin
                                      menuTags,
                                      menuItems,
                                      reload,
                                      copyLink,
                                      setAddingToFamilyId,
                                      addingToFamilyId,
                                      addSelectedMembers,
                                      setAddSelectedMembers,
                                      addMembersToFamily,
                                  }) {
    // ---------- режим редактирования ----------
    const [editMode, setEditMode] = useState(false);
    const [draft, setDraft] = useState({
        name: family.name,
        description: family.description,
    });

    // ---------- подтверждение удаления ----------
    const [confirmDel, setConfirmDel] = useState(null);

    // ---------- сохранение изменений ----------
    const saveChanges = async () => {
        try {
            await axios.patch(`/api/admin/families/${family.id}`, draft);
            setEditMode(false);
            reload();
        } catch (e) {
            alert(e.response?.data?.detail || "Не удалось сохранить семью");
        }
    };

    // ---------- отмена редактирования ----------
    const cancelChanges = () => {
        setDraft({name: family.name, description: family.description});
        setEditMode(false);
    };
    // автокомплит
    const [searchQuery, setSearchQuery] = useState("");
    // ---------- удаление ----------
    const deleteFamily = async (full) => {
        try {
            await axios.delete(
                `/api/admin/families/${family.id}${full ? "?full=true" : ""}`
            );
            setConfirmDel(null);
            reload();
        } catch (e) {
            alert(e.response?.data?.detail || "Не удалось удалить семью");
        }
    };

    return (
        <div className="bg-white p-6 mb-4 rounded-lg shadow">
            {/* ---------- заголовок и управление семьёй ---------- */}
            <div className="flex items-center justify-between mb-3">
                {editMode ? (
                    <>
                        <input
                            className="p-1 border rounded w-1/2 mr-2"
                            value={draft.name}
                            placeholder="Название семьи"
                            onChange={(e) => setDraft({...draft, name: e.target.value})}
                        />
                        <input
                            className="p-1 border rounded w-1/2"
                            value={draft.description ?? ""}
                            placeholder="Описание"
                            onChange={(e) =>
                                setDraft({...draft, description: e.target.value})
                            }
                        />
                    </>
                ) : (
                    <>
                        <h3 className="text-xl font-bold">{family.name || "Без названия"}</h3>
                        {family.description && (
                            <span className="text-sm text-gray-600 ml-2">
                {family.description}
              </span>
                        )}
                    </>
                )}

                {/* ---------- кнопки управления ---------- */}
                <div className="flex items-center gap-2">
                    {editMode ? (
                        <>
                            <button
                                onClick={saveChanges}
                                title="Сохранить"
                                className="text-green-600"
                            >
                                <CheckIcon className="h-5 w-5"/>
                            </button>
                            <button
                                onClick={cancelChanges}
                                title="Отмена"
                                className="text-gray-600"
                            >
                                <XMarkIcon className="h-5 w-5"/>
                            </button>
                        </>
                    ) : (
                        <button
                            onClick={() => setEditMode(true)}
                            title="Редактировать"
                            className="text-blue-600"
                        >
                            <PencilIcon className="h-5 w-5"/>
                        </button>
                    )}

                    {/* Удалить только семью (оставить гостей) */}
                    <button
                        onClick={() => setConfirmDel("only")}
                        title="Удалить только семью"
                        className="text-yellow-600"
                    >
                        <TrashIcon className="h-5 w-5"/>
                    </button>

                    {/* Полное удаление семьи + гостей */}
                    <button
                        onClick={() => setConfirmDel("full")}
                        title="Полностью удалить семью и гостей"
                        className="text-red-600"
                    >
                        <TrashIcon className="h-5 w-5"/>
                    </button>
                </div>
            </div>

            {/* ---------- список участников семьи (теперь с редактированием) ---------- */}
            <ul className="space-y-2">
                {family.members.map((link) => (
                    <MemberRow
                        key={link.id}
                        member={link.member}
                        familyId={family.id}
                        linkId={link.id}
                        canVote={link.can_vote_for_others}
                        menuTag={menuTags?.[link.member.id]}
                        menuItems={menuItems}
                        reload={reload}
                        copyLink={copyLink}
                    />
                ))}
            </ul>

            {/* ---------- Добавить участников ---------- */}
            <button
                onClick={() => setAddingToFamilyId(family.id)}
                className="mt-4 text-sm bg-gold-accent text-white px-4 py-2 rounded  hover:bg-yellow-600"
            >
                Добавить участников
            </button>

            {addingToFamilyId === family.id && (
                <div className="mt-4 p-4 bg-gray-100 rounded">
                    <h4 className="mb-2">Добавить в {family.name}</h4>

                    <input
                        type="text"
                        className="w-full p-2 border rounded mb-4"
                        placeholder="Поиск по ФИО (например, 'Ив')"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />

                    <div className="max-h-64 overflow-y-auto space-y-2 mb-4">
                        {members
                            .filter(
                                (m) => !family.members.some((link) => link.member.id === m.id)  // Уже фильтр на не-в-семье
                            )
                            .filter((m) => {  // + Новый фильтр по поиску
                                const fullName = `${m.last_name} ${m.first_name} ${m.patronymic || ""}`.toLowerCase();
                                return fullName.includes(searchQuery.toLowerCase());
                            })
                            .map((m) => (
                                <label
                                    key={m.id}
                                    className="flex items-center justify-between bg-gray-50 p-3 rounded"
                                >
                  <span>
                    {m.last_name} {m.first_name} {m.patronymic || ""}
                  </span>
                                    <div className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            checked={addSelectedMembers[m.id] != null}
                                            onChange={(e) =>
                                                setAddSelectedMembers({
                                                    ...addSelectedMembers,
                                                    [m.id]: e.target.checked ? false : null,
                                                })
                                            }
                                        />
                                        <span className="ml-1">включить</span>

                                        <input
                                            type="checkbox"
                                            checked={addSelectedMembers[m.id] === true}
                                            disabled={addSelectedMembers[m.id] == null}
                                            onChange={(e) =>
                                                setAddSelectedMembers({
                                                    ...addSelectedMembers,
                                                    [m.id]: e.target.checked ? true : false,
                                                })
                                            }
                                        />
                                        <span className="ml-1">отвечает за всех</span>
                                    </div>
                                </label>
                            ))}
                    </div>

                    <button
                        onClick={() => addMembersToFamily(family.id)}
                        className="w-full bg-gold-accent text-white py-2 rounded"
                    >
                        Добавить
                    </button>
                    <button
                        onClick={() => setAddingToFamilyId(null)}
                        className="w-full mt-2 bg-gray-200 py-2 rounded"
                    >
                        Отмена
                    </button>
                </div>
            )}

            {/* ---------- модальное окно подтверждения ---------- */}
            {confirmDel && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
                    <div className="bg-white p-4 rounded shadow-md">
                        <p className="mb-3">
                            {confirmDel === "full"
                                ? "Удалить семью и всех её гостей из базы?"
                                : "Удалить только семью (гости останутся в базе)?"}
                        </p>
                        <div className="flex justify-end gap-2">
                            <button
                                className="px-3 py-1 bg-gray-200 rounded"
                                onClick={() => setConfirmDel(null)}
                            >
                                Отмена
                            </button>
                            <button
                                className="px-3 py-1 bg-red-600 text-white rounded"
                                onClick={() => {
                                    deleteFamily(confirmDel === "full");
                                }}
                            >
                                Да, удалить
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}